import { useSingleDataQuery } from 'hooks/useFastGqlQuery';
import { useSelector } from 'react-redux';
import UserSelectors from 'redux/user/user.selectors';
import { GET_SINGLE_USER } from 'services/graphql/queries/user.query';
import { GeneralFunction } from 'types/common';
import { IUser } from 'types/user';

const useCurrentLoggedInUser = (props?: Partial<{ getNew: boolean; cache: string }>) => {
  const getNew = props?.getNew;
  const cache = props?.cache;
  const userFromRedux = useSelector(UserSelectors.selectUser);
  const userId = userFromRedux.id;
  const { content, loading, refetch } = useSingleDataQuery<IUser>(GET_SINGLE_USER, {
    variables: { id: userId },
    fetchPolicy: cache || getNew ? 'cache-and-network' : 'cache-first',
    skip: !userId,
  });

  const baseContent = { userFetchLoading: loading, id: userId, refetchCurrentLoggedInUser: refetch };
  return { ...(content || {}), ...baseContent } as IUser & {
    userFetchLoading: boolean;
    refetchCurrentLoggedInUser: GeneralFunction;
  };
};

export default useCurrentLoggedInUser;
